import React from "react";

const CircleSign = () => {
  return (
    <svg height="10" width="10">
      <circle
        cx="5"
        cy="5"
        r="3"
        stroke="rgb(0,40,85)"
        strokeWidth="1"
        fill="rgb(0,40,85)"
      />
    </svg>
  );
};

export default CircleSign;
